<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
          <v-card>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon>mdi-hexagon-multiple</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">工事情報詳細</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                  <v-row>
                    <v-col cols="8">
                      <v-divider/>
                      <v-data-table :headers="headers" :items="items" hide-default-header hide-default-footer dense>
                          <template v-slot:no-data>データを取得できません</template>
                      </v-data-table>
                      <v-divider/>
                    </v-col>
                    <v-col cols="4">
                      <v-btn v-if="constructionUpdatePermission" class="mb-2" block depressed color="primary" :to="{ name: 'EditConstructionMaster', params: { id: this.constructionId } }">工事情報編集</v-btn>
                      <v-btn v-if="constructionUpdatePermission" class="mb-2" block depressed color="primary" @click.stop="copyDialogDrawer = true">工事情報複製</v-btn>
                      <v-divider v-if="constructionUpdatePermission" class="mb-2"/>
                      <v-btn v-if="budgetUpdatePermission && isNotBudgetData && !isCompleted" class="mb-2" block depressed color="success" :to="{ name: 'WorkingBudgetStore', params: { id: this.constructionId } }">実行予算作成</v-btn>
                      <v-btn v-if="budgetUpdatePermission && isBudgetData && !isCompleted" class="mb-2" block depressed color="warning" @click="managerCheck">実行予算変更</v-btn>
                      <v-btn v-if="budgetReadPermission && isBudgetData" class="mb-2" block depressed color="info" :to="{ name: 'WorkingBudgetInfo', params: { id: this.constructionId, budget: this.budgetId } }">プレビュー</v-btn>
                      <v-btn v-if="budgetReadPermission && isBudgetData && (isReceived || isAchievementsReflected)" class="mb-2" block depressed color="info" :to="{ name: 'AchievementInfo', params: { id: this.constructionId, budget: this.budgetId } }">実績情報</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn v-if="budgetUpdatePermission && isBudgetData" depressed color="success" @click.prevent="download"><v-icon>mdi-file-download</v-icon> 実行予算書ダウンロード</v-btn>
                  <v-btn v-if="budgetUpdatePermission && isNotReceived" depressed color="success" :disabled="isNotBudgetData" @click.prevent="acceptDialog">受注</v-btn>
                  <v-btn v-if="budgetUpdatePermission && isNotReceived" depressed color="error" :disabled="isNotBudgetData" @click.stop="forfeitDialogDrawer=!forfeitDialogDrawer">失注</v-btn>
                  <v-btn v-if="budgetUpdatePermission && isReceived" depressed color="success" @click.stop="completeDialogDrawer=!completeDialogDrawer">工事完了</v-btn>
                  <v-btn depressed color="grey lighten-1" :to="{ name: 'ConstructionMaster' }">戻る</v-btn>
                </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="acceptDialogDrawer" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">受注登録</v-card-title>
            <v-container>
                <v-card-text>
                  『{{ constructionName }}』を受注します。<br/>
                  請負金額を入力してください。<br/>
                </v-card-text>
                <v-form ref="store_accept_price_form" v-model="acceptValid" @submit.prevent>
                  <v-text-field v-model="acceptPrice" prefix="¥" label="請負金額" :rules="acceptPriceRules" dense outlined required>
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="acceptDialogDrawer=!acceptDialogDrawer">キャンセル</v-btn>
                    <v-btn depressed color="success" :disabled="!acceptValid" @click.prevent="accept">受注</v-btn>
                </v-card-actions>
            </v-container>
          </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="forfeitDialogDrawer" persistent max-width="500">
          <v-card>
              <v-container>
                <v-card-title class="headline">失注登録</v-card-title>
                <v-card-text>
                  『{{ constructionName }}』を失注とします。<br/>
                  よろしいですか？
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="forfeitDialogDrawer=!forfeitDialogDrawer">キャンセル</v-btn>
                    <v-btn depressed color="error" @click.prevent="forfeit">失注</v-btn>
                </v-card-actions>
              </v-container>
          </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="completeDialogDrawer" persistent max-width="500">
          <v-card>
              <v-container>
                <v-card-title class="headline">工事完了</v-card-title>
                <v-card-text>
                  『{{ constructionName }}』を工事完了とします。<br/>
                  よろしいですか？
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="completeDialogDrawer=!completeDialogDrawer">キャンセル</v-btn>
                    <v-btn depressed color="success" @click.prevent="complete">工事完了</v-btn>
                </v-card-actions>
              </v-container>
          </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="managerCheckDialogDrawer" persistent max-width="500">
          <v-card>
              <v-container>
                <v-card-title class="headline">ユーザー確認</v-card-title>
                <v-card-text>
                  ログインユーザーが監督者ではありません。<br/>
                  実行予算書を変更しますか？
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="grey lighten-1" @click.stop="managerCheckDialogDrawer=!managerCheckDialogDrawer">キャンセル</v-btn>
                    <v-btn depressed color="error" @click.prevent="managerCheckDialogHandler">変更する</v-btn>
                </v-card-actions>
              </v-container>
          </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="copyDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title>
            <div>工事情報複製</div>
          </v-card-title>
          <v-card-text>
            <p>『{{ constructionName }}』を複製します。 <br/>
              よろしいですか?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click="copyDialogDrawer = false">キャンセル</v-btn>
            <v-btn depressed color="success" @click="copy()">複製</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import CalcCommon from "@/helpers/calcCommon";
  import Rule from "@/validation/rules";
  import ConstructionApi from "@/api/construction-api"
  import BudgetExcelApi from "@/api/budget-excel-api"
  import { saveAs } from 'file-saver';

  export default {
    name: "ConstructionMasterDetail",
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      constructionId: null,
      constructionManagerId: null,
      budgetId: null,
      departmentId: null,
      updateConstructionNumber: "",
      updateConstructionNumberSerial: 0,
      constructionName: "",

      headers: [
        { text: "項目名", value: "text" },
        { text: "データ", value: "data" },
      ],
      items: [],
      statuses: {
        notReceived: { name: "未受注", value: 0 },
        received: { name: "受注済", value: 1 },
        missing: { name: "失注済", value: 2 },
        reflect: { name: "実績反映済", value: 3 }
      },
      isNotBudgetData: false,
      isBudgetData: false,
      isNotReceived: false,
      isReceived: false,
      isCompleted: false,
      isAchievementsReflected: false,

      acceptPrice: 0,
      acceptDialogDrawer: false,
      forfeitDialogDrawer: false,
      completeDialogDrawer: false,
      managerCheckDialogDrawer: false,
      copyDialogDrawer: false,
      // copyConstructionId: null,

      acceptPriceRules: Rule.acceptPriceRules,
      acceptValid: false,

      // 権限
      constructionUpdatePermission: true,
      budgetReadPermission: true,
      budgetUpdatePermission: true

    }),
    created () {
      this.initialize ()
    },
    watch: {
      acceptPrice (value) { this.acceptPrice = this.stringFormat(value); },
    },
    beforeRouteUpdate(to, from, next) {
      next();
      window.location.reload();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        if (this.user.role_id == 0) {
          this.constructionUpdatePermission = this.user.permission_config.CTSG00010.update;
          this.budgetReadPermission = this.user.permission_config.CTSG00011.read;
          this.budgetUpdatePermission = this.user.permission_config.CTSG00011.update;
        }
        this.budgetExcelApi = new BudgetExcelApi();
        this.constructionApi = new ConstructionApi();
        this.constructionId = this.$route.params.id;
        const promise = this.constructionApi.info(this.constructionId);
        promise.then((response) => {
          // 受注時工番発行
          for (var department of response.data.body.department_list) {
            if (department.id === response.data.body.construction_info.department_id) {
              this.departmentId = department.id;
              // this.updateConstructionNumberSerial = department.construction_number_serial;
              // this.updateConstructionNumber =
              // department.construction_number_fixed +
              // this.updateConstructionNumberSerial.toString().padStart(department.digits, '0');
              break;
            }
          }
          this.constructionName = response.data.body.construction_info.construction_name;
          if (this.statuses.notReceived.value === response.data.body.construction_info.status) {
            this.isNotReceived = true;
          }
          if (this.statuses.received.value === response.data.body.construction_info.status ) {
            this.isReceived = true;
          }
          if (this.statuses.reflect.value === response.data.body.construction_info.status ) {
            this.isAchievementsReflected = true;
          }
          if (this.statuses.reflect.value === response.data.body.construction_info.status ||
              this.statuses.missing.value === response.data.body.construction_info.status) {
            this.isCompleted = true;
          }
          this.constructionManagerId = response.data.body.construction_info.management_user
          this.items = [
              {text: "ステータス", data: this.getStatusName(response.data.body.construction_info.status)},
              {text: "工番", data: response.data.body.construction_info.construction_number},
              {text: "工事名", data: this.constructionName},
              {text: "現場名", data: response.data.body.construction_info.place},
              {text: "工期(自)", data: response.data.body.construction_info.start_date},
              {text: "工期(至)", data: response.data.body.construction_info.end_date},
              {text: "発注者", data: response.data.body.construction_info.order_name},
              {text: "施工者", data: response.data.body.construction_info.builder_name},
              {text: "監督者", data: response.data.body.construction_info.management_user_name},
              {text: "請負金額", data: CalcCommon.addFigure(response.data.body.construction_info.estimated_price)}
          ];
          if (response.data.body.budget_latest_info.length === 0) {
            this.isNotBudgetData = true;
          } else {
            this.isBudgetData = true;
            this.budgetId = response.data.body.budget_latest_info.id;
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      stringFormat(value) {
        var result = value.toString()
        while (result.match(/[０-９]/g)) {
          result = result.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
          });
        }
        return result;
      },
      getStatusName (status) {
          var result = null;
          for (var index in this.statuses) {
              if (this.statuses[index].value === status) {
                  result = this.statuses[index].name;
                  break;
              }
          }
          return result;
      },
      acceptDialog () {
        if (this.$refs.store_accept_price_form) {
          this.$refs.store_accept_price_form.resetValidation();
        }
        this.acceptPrice = 0;
        this.acceptDialogDrawer = true;
      },
      accept () {
        this.isLoading();
        const params = {
          status: this.statuses.received.value,
          // construction_number: this.updateConstructionNumber,
          department_id: this.departmentId,
          // construction_number_serial: this.updateConstructionNumberSerial + 1,
          estimated_price: this.acceptPrice
        }
        const promise = this.constructionApi.update(this.constructionId, params)
        promise.then((response) => {
            this.$emit('success', response.data.message)
            this.items[0].data = this.getStatusName(this.statuses.received.value);
            this.items[1].data = response.data.number;
            this.items[9].data = CalcCommon.addFigure(this.acceptPrice);
            this.isNotReceived = false;
            this.isReceived = true;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.acceptDialogDrawer = false;
          this.isLoading();
        });
      },
      forfeit () {
        this.isLoading();
        const params = {
          status: this.statuses.missing.value,
          department_id: this.departmentId
        }
        const promise = this.constructionApi.update(this.constructionId, params)
        promise.then((response) => {
            this.$emit('success', response.data.message)
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.forfeitDialogDrawer = false;
          this.items[0].data = this.getStatusName(this.statuses.missing.value);
          this.isNotReceived = false;
          this.isCompleted = true;
          this.isAchievementsReflected = false;
          this.isLoading();
        });
      },
      complete () {
        this.isLoading();
        const params = {
          status: this.statuses.reflect.value,
          department_id: this.departmentId
        }
        const promise = this.constructionApi.update(this.constructionId, params)
        promise.then((response) => {
            this.$emit('success', response.data.message)
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.completeDialogDrawer = false;
          this.items[0].data = this.getStatusName(this.statuses.reflect.value);
          this.isReceived = false;
          this.isCompleted = true;
          this.isAchievementsReflected = true;
          this.isLoading();
        });
      },
      managerCheck () {
        if (this.user.user_id == this.constructionManagerId) {
          this.$router.push({ name: 'WorkingBudgetEdit', params: { id: this.constructionId, budget: this.budgetId } });
        } else {
          this.managerCheckDialogDrawer = true;
        }
      },
      managerCheckDialogHandler () {
        this.managerCheckDialogDrawer = false;
        this.$router.push({ name: 'WorkingBudgetEdit', params: { id: this.constructionId, budget: this.budgetId } });
      },
      download() {
        this.isLoading();
        const promise = this.budgetExcelApi.download(this.constructionId);
        promise.then((response) => {
          saveAs(response.data.body.url, response.data.body.filename);
          this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました");
          }
        }).finally(() => {
          this.isLoading();
        })
      },
      copy() {
        this.isLoading();
        const promise = this.constructionApi.copy(this.constructionId);
        promise.then((response) => {
          this.$emit('success', response.data.message);
          const copyId = response.data.body.copyId;
          this.$router.push({ name: 'ConstructionMasterDetail', params: { id: copyId } });
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました");
          }
        }).finally(() => {
          this.isLoading();
        })
      }
    },
  };
</script>
